import PatientData from "../component/admin/patientDetails";

const propertise =
{
    PatientSatus: 1932,
    PatientUniqueId: 1859,
    PatientMrnNumber: 1929,
    PatientPasportNumber: 1558,
    PatientEmairatesID: 1930,
    PatientMobileNumber: 30,
    PatientFirstName: 16,
    PatientLastName: 18,
    PatientDiagramImage: 1951,
    patientFormId: 1,
    EMRID: 1859,
    patientAdmit: 3,
    NursesNotes: 72,
    dischargeForm: 44,
    patientTransfer: 31,
    adtForm: 4,
    medPassFormId: 131,
    medPassDrugFormId: 130,
    formHeading: 17,
    masterDataDropdownList: 20,
    preHDformId: 121,
    duringHDformId: 122,
    postHDformId: 123,
    drugListFieldId: 2199,
    rxFormMedicationDropdown: 2241,
    rxFormAncillaryDropdown: 2243,
    ancillaryFormId : 132,
    ancillaryFieldId : 2242,
    schedulingFieldIdForMedpass : 2233,
    administeringTimeFiledId : 2244
};


export const reportsFileds = {
    PatientUniqueId: 1859,
    PatientMrnNumber: 1929,
    staffName: 'staffName',
    DateOfAddmission: 792
}

export default propertise;